const EN = {
    title: 'Data',
    subTitles: {
        address: 'Address',
        email: 'E-mail',
        telephone: 'Phone number',
        device: 'Devices'
    },
    subDescriptions: {
        address: 'Legal Address',
        email: 'E-mail',
        telephone: 'Phone number'
    },
    inputs: {
        document: 'INE',
        cuit: 'RFC',
        nationality: 'Nationality',
        gender: 'Gender',
        birthdate: 'Birthdate',
        level: 'Level',
        email: 'E-mail',
        maritalStatus: 'Marital status',
        dwellTime: 'Dwell Time',
        phoneNumber: 'Phone number',
        profession: 'Profession',
        male: 'Male',
        female: 'Female',
        category: 'Category',
        recipient: 'Recipient',
        title: 'Title',
        subtitle: 'Subtitle',
        description: 'Description',
        publishDate: 'Date and time of publication',
    },
    subInputs: {
        address: 'Address',
        country: 'Country',
        province: 'Province',
        location: 'Location',
        street: 'Street',
        zipCode: 'Zip code'
    },
    realAddressInputs: {
        address: 'Real address',
        country: 'Country',
        province: 'Province',
        location: 'Location',
        streetAddr: 'Street',
        streetNum: 'Street number',
        floor: 'Floor',
        dept: 'Department',
        zipCode: 'Zip code'
    },
    extra: {
        title: 'Extra data',
        subject: 'Obligated subject'
    },
    civilStatus: {
        married: 'Married',
        single: 'Single',
        concubinage: 'Concubinage'
    },
    level: {
        diamond: 'Diamond',
        sapphire: 'Sapphire',
        golden: 'Golden',
        silver: 'Silver',
        bronze: 'Bronze'
    },
    dialog: {
        block: {
            title: 'Client block',
            description: 'You are going to block the client ',
        },
        pin: {
            title: 'Unblock client',
            description: {
                0: 'Sending the pin to ',
                1: 'Please verify that the number is correct.'
            }
        },
        recoverPassword: {
            title: 'Recover password',
            description: {
                0: 'You are going to send the mail to the client ',
                1: 'with the link of password recovery.',
            }
        },
        blockPaymentLink: {
            title: '¿Do you want to block the\ngeneration of payment links for',
        },
        unblockPaymentLink: {
            title: '¿Do you want to enable the\ngeneration of payment links for',
        }
    },
    alert: {
        userBlocked: 'The user has been blocked successfully.',
        activateError: 'Error trying to activate the user.',
        sendPin: 'The unblock PIN code has been sent correctly.',
        pinSuccess: 'The user status has been changed to recover and the unblock PIN code has been sent.',
        blockPaymentLink: 'The generation status has changed.',
        errorBlockPaymentLink: 'Error while changing the status.',
        invalidPhone: 'Invalid phone number.',
        validationSuccess: 'The client validation was successfully applied.',
        mailSuccess: 'The email has been sent successfully.',
        invalidMail: 'The email is invalid.'
    }
};

export default EN;
